import {ReactComponent as BillaloSvg} from "svg/billalo.svg"
export const BillaloLogo: React.FC<
React.SVGProps<SVGSVGElement>
> = ({ ...attributes }) => {
  
  return (<BillaloSvg fill="#0062FF" {...attributes}/>
  );
};
export default BillaloLogo;
